enum COOKIES_KEY {
  AUTHORIZATION = 'authorization',
  REFRESH_TOKEN = 'refresh_token',
}

export default COOKIES_KEY;
